import { Alert, Col, Form, Input, Radio, Row } from "antd";
import React from "react";
import "./StepsOrg.scss";
import { observaciones, radioButton } from "../../../../utils/rules";
import { base64ToBlob } from "../../../../utils/Others/function";
import { useEffect } from "react";
import { useState } from "react";

export default function ValidaDocOrg(props) {
    const { organizacion, getFieldDecorator, onChangeRadio, form, observacionesAux, disabled } = props;
    //Para poder visualizar pdfs grandes es necesario convertir de base64 a objeto blob
    const blob = base64ToBlob( organizacion.urlSolicitudVista, 'application/pdf' );
    const [url, setUrl] = useState();

    useEffect(() => {
        //Se crea objeto url para visualizar el pdf que apunta al objeto blob creado, se usa en el useEffect
        //para que solo renderize una vez el pdf y no al estar contestando las preguntas
        setUrl(URL.createObjectURL( blob ));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
        <Row gutter={20}>
            <Col span={12}>
                <h4>Soporte documental</h4>
                {organizacion.urlSolicitudVista !== null ? (
                    <>
                    <embed src={url}
                        type="application/pdf"
                        width="100%"
                        height="400px"
                    />
                    </>
                ) : (
                    <>
                    <Alert message="No se cargó el soporte documental."
                        type="info" showIcon
                    />
                    </>
                )}
            </Col>
            <Col span={12}>
                <h4>Datos capturados</h4>
                <div className="datosCapturados">
                    <Row>
                        <Col span={24} className="paddingDatos">
                            <Form.Item label="¿El soporte documental cargado es correcto?" style={{fontWeight: "bold"}}>
                                {getFieldDecorator("validaDoc", {
                                    rules: radioButton,
                                    initialValue: observacionesAux.validaDoc,
                                })(
                                    <Radio.Group onChange={onChangeRadio("validaDoc")} style={{fontWeight: "normal"}}
                                        disabled={disabled.validaDoc}
                                    >
                                        <Radio value={true}>Sí</Radio>
                                        <Radio value={false}>No</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    {form.getFieldValue("validaDoc") === false && (
                        <>
                        <Row>
                            <Col span={24} className="paddingObs">
                                <Form.Item label="Observaciones" style={{fontWeight: "bold"}}>
                                    {getFieldDecorator("validaDocObs", {
                                        rules: observaciones,
                                        initialValue: observacionesAux.validaDocObs,
                                    })(
                                        <Input.TextArea onChange={onChangeRadio("validaDocObs")}
                                            maxLength={150} disabled={disabled.validaDoc}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        </>
                    )}
                </div>
            </Col>
        </Row>
        </>
    );

}